export default function extractMicrioUrlParts(url) {
  if (!url || url.indexOf('.micr.io/') === -1) {
    return {}
  }

  const regex = /(?:.*\.micr\.io\/)([a-zA-Z0-9]{5})(?:\/([a-zA-Z0-9-]*))?(?:\/([a-zA-Z0-9-]*))?(?:\/([a-zA-Z0-9-]*))?(?:\/([a-zA-Z0-9-]*))?(?:\/|$)/
  const matches = regex.exec(url) || []

  return {
    objectId: matches[1] ?? null,
    imageTitle: matches[2] && matches[2]?.length > 2 ? matches[2] : null,
    language: matches[2] && matches[2]?.length === 2 ? matches[2] : null,
    tourSlug: matches[3] ?? null,
    tourTitle: matches[4] ?? null,
    stepSlug: matches[5] ?? null,
  }
}
